interface StoredSession {
  access_token?: string
  expires_at?: number
}

export function isSupabaseConfigured(): boolean {
  return Boolean(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY)
}

/** Read Supabase access token from localStorage without loading the SDK. */
export function readStoredAccessToken(): string | null {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (!key?.startsWith('sb-') || !key.endsWith('-auth-token')) continue

      const raw = localStorage.getItem(key)
      if (!raw) continue

      const parsed = JSON.parse(raw) as StoredSession
      if (!parsed.access_token) continue

      if (parsed.expires_at && parsed.expires_at * 1000 <= Date.now()) continue

      return parsed.access_token
    }
  } catch {
    // Ignore malformed storage
  }
  return null
}
